exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config-container[data-v-7dc7a182]{background:#d4e5fe;border-radius:10px}.config-container .config-item[data-v-7dc7a182]{margin:10px;padding:10px;text-align:left;cursor:pointer;border-radius:10px}.config-container .is-select[data-v-7dc7a182]{background:#2e5aff;color:#fff}.config-container .config-item[data-v-7dc7a182]:hover{background:#2e5aff;color:#fff}", ""]);

// exports
